/** @format */

import React, { useEffect, useRef, useState } from "react";
import PdfViewer from "./PdfPreviewer";
import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAllCoordinates } from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { Tools } from "../Pdf-Utils/Tools";
import { Stack, Box, TextField, Typography, Divider, Button, MenuItem } from "@mui/material";
import PdfControls from "./PdfControls";
import PdfMiniSidenav from '../../../components/Esign/pdfMiniSidenav';
import {
  ex,
  kycDefaultSelectData,
  transformData,
  transformSelectData,
} from "./../../../Helpers";
import { selectOptions } from "../../../store/reducers/pdfeditor/selectOptionsSlice";
import { esignToolApi } from "../../../services/esignApi";
// import { kycApi } from "../../../services/PdfEditor/kycApi";
// import { closureApi } from "../../../services/PdfEditor/closureApi";
// import { ipoApi } from "../../../services/PdfEditor/ipoApi";
// import { rekycApi } from "../../../services/PdfEditor/rekycApi";
import { toast } from "react-toastify";

const PdfViewport = (open, setOpen) => {
  const containerRef = useRef(null);
  const pdfPagesRef = useRef([]);
  const [pdfPages, setPdfPages] = useState(null);
  const { setOpenSideBar, openSideBar } = useOutletContext();
  const { uploadedDocument } = useSelector((state) => state.uploadDocument);
  const { signers } = useSelector((state) => state.signers);
  const [coordinateTemplates, setCoordinateTemplates] = useState([]);
  const [selectedCoordinateTemplate, setSelectedCoordinateTemplate] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    console.log("uploadedDocument",uploadedDocument)
    if (uploadedDocument) {
      let data = transformData(uploadedDocument?.data?.document_template);
      dispatch(updateAllCoordinates(data));
    }
    setOpenSideBar(true);
  }, [uploadedDocument]);
  
  let dataa = {
    AADHAR_NO: "text",
    COR_ADD1: "text",
    COR_ADD2: "text",
    COR_ADD3: "text",
    COR_CITY: "text",
    COR_PINCD: "text",
    COR_STATE: "text",
    FATHER_NAME: "text",
    GENDER: "text",
    NA: "image",
    PER_ADD1: "text",
    PER_ADD2: "text",
    PER_ADD3: "text",
    PER_CITY: "text",
    PER_PINCD: "text",
    PER_STATE: "text",
    aadhar_address: "text",
    aadhar_country: "text",
    aadhar_dist: "text",
    aadhar_dob: "text",
    aadhar_fathername: "text",
    aadhar_file: "image",
    aadhar_gender: "text",
    aadhar_house: "text",
    aadhar_image: "image",
    aadhar_name: "text",
    aadhar_no: "text",
    aadhar_pincode: "text",
    aadhar_seeding_status: "text",
    aadhar_state: "text",
    account_number: "text",
    account_type: {
      type: "select",
      values: ["Saving Account", "Current Account"],
    },
    activestatus: "text",
    add_2_nominee: "checkbox",
    add_3_nominee: "checkbox",
    add_nominee: {
      type: "select",
      values: ["Yes", "No"],
    },
    annual_income: {
      type: "select",
      values: [
        "Below 1 Lac",
        "1-5 Lac",
        "5-10 Lac",
        "10-25 Lac",
        "More Than 25 Lac",
      ],
    },
    backoffice_timestamp: "date",
    bankAddress: "text",
    bankName: "text",
    bank_address: "text",
    bank_city: "text",
    bank_district: "text",
    bank_pincode: "text",
    bank_state: "text",
    bank_timestamp: "date",
    bank_upload_timestamp: "date",
    bankverify: "text",
    boid: "text",
    branchName: "text",
    branch_reference_code: "text",
    bse_cash: "checkbox",
    bse_currency: "checkbox",
    bse_fo: "checkbox",
    bse_timestamp: "date",
    bse_uat_timestamp: "date",
    clientimage: "image",
    clienttoken: "text",
    current_date: "text",
    current_day: "text",
    current_month: "text",
    current_year: "text",
    detailspan_timestamp: "date",
    digilocker_timestamp: "date",
    digitalsignature: "text",
    digitrans: "text",
    do_you_want_to_execute_ddpi: {
      type: "select",
      values: ["Yes", "No"],
    },
    dob: "text",
    education: {
      type: "select",
      values: [
        "Under Graduate",
        "Graduate",
        "Post Graduate",
        "Professional",
        "Others",
      ],
    },
    email: "text",
    email_otp_timestamp: "date",
    email_timestamp: "date",
    equity_plan: "text",
    esign_timestamp: "date",
    father_name: "text",
    gender: {
      type: "select",
      values: ["Male", "Female", "Others"],
    },
    google_signin: "text",
    guardian1_add1: "text",
    guardian1_city: "text",
    guardian1_country: "text",
    guardian1_dob: "text",
    guardian1_email: "text",
    guardian1_mobile: "text",
    guardian1_name: "text",
    guardian1_pincode: "text",
    guardian1_relation: {
      type: "select",
      values: [
        "Brother ",
        "Sister",
        "Son",
        "Daughter",
        "Mother",
        "Father",
        "Cousin",
        "Nephew",
        "Grand-father",
        "Grand-mother",
        "Wife",
        "Husband",
        "Friend",
        "Uncle",
        "Aunty",
        "Other",
      ],
    },
    guardian1_state: "text",
    guardian2_add1: "text",
    guardian2_city: "text",
    guardian2_country: "text",
    guardian2_dob: "text",
    guardian2_email: "text",
    guardian2_mobile: "text",
    guardian2_name: "text",
    guardian2_pincode: "text",
    guardian2_relation: {
      type: "select",
      values: [
        "Brother",
        "Sister",
        "Daughter",
        "Father",
        "Nephew",
        "Grand-father",
        "Grand-mother",
        "Cousin",
        "Son",
        "Wife",
        "Mother",
        "Husband",
        "Friend",
        "Uncle",
        "Aunty",
        "Other",
      ],
    },
    guardian2_state: "text",
    guardian3_add1: "text",
    guardian3_city: "text",
    guardian3_country: "text",
    guardian3_dob: "text",
    guardian3_email: "text",
    guardian3_mobile: "text",
    guardian3_name: "text",
    guardian3_pincode: "text",
    guardian3_relation: {
      type: "select",
      values: [
        "Brother",
        "Sister",
        "Daughter",
        "Mother",
        "Father",
        "Son",
        "Grand-daughter",
        "Grand-son",
        "Grand-father",
        "Grand-mother",
        "Wife",
        "Husband",
        "Uncle",
        "Aunty",
        "Friend",
        "Other",
      ],
    },
    guardian3_state: "text",
    ifsc: "text",
    income_proof_timestamp: "date",
    latitude: "text",
    liveimage_timestamp: "date",
    locality: "text",
    location: "text",
    longitude: "text",
    marital_status: {
      type: "select",
      values: ["Single", "Married"],
    },
    micr: "text",
    micr1: "text",
    mobile_number: "text",
    mobile_otp_timestamp: "date",
    mobile_timestamp: "date",
    mother_name: "text",
    name: "text",
    nominee1_add1: "text",
    nominee1_add2: "text",
    nominee1_country: "text",
    nominee1_dob: "text",
    nominee1_email: "text",
    nominee1_mobile: "text",
    nominee1_name: "text",
    nominee1_pan: "text",
    nominee1_pincode: "text",
    nominee1_relation: {
      type: "select",
      values: [
        "Brother",
        "Daughter",
        "Father",
        "Nephew",
        "Grand-father",
        "Grand-mother",
        "Cousin",
        "Mother",
        "Son",
        "Sister",
        "Wife",
        "Friend",
        "Uncle",
        "Aunty",
        "Other",
        "Cousin",
      ],
    },
    nominee1_same_as_my_address: "checkbox",
    nominee1_state: "text",
    nominee2_add1: "text",
    nominee2_add2: "text",
    nominee2_country: "text",
    nominee2_dob: "text",
    nominee2_email: "text",
    nominee2_mobile: "text",
    nominee2_name: "text",
    nominee2_pan: "text",
    nominee2_pincode: "text",
    nominee2_relation: {
      type: "select",
      values: [
        "Mother",
        "Father",
        "Son",
        "Sister",
        "Grand-mother",
        "Grand-father",
        "Nephew",
        "Daughter",
        "Cousin",
        "Wife",
        "Husband",
        "Friend",
        "Uncle",
        "Aunty",
        "Other",
        "Brother",
      ],
    },
    nominee2_same_as_my_address: "checkbox",
    nominee2_state: "text",
    nominee3_add1: "text",
    nominee3_add2: "text",
    nominee3_city: "text",
    nominee3_country: "text",
    nominee3_dob: "text",
    nominee3_email: "text",
    nominee3_mobile: "text",
    nominee3_name: "text",
    nominee3_pan: "text",
    nominee3_percentage: "text",
    nominee3_pincode: "text",
    nominee3_relation: {
      type: "select",
      values: [
        "Brother",
        "Sister",
        "Daughter",
        "Father",
        "Mother",
        "Grand-father",
        "Nephew",
        "Cousin",
        "Grand-mother",
        "Wife",
        "Son",
        "Husband",
        "Friend",
        "Uncle",
        "Aunty",
        "Other",
      ],
    },
    nominee3_same_as_my_address: "checkbox",
    nominee3_state: "text",
    nominee_1_city: "text",
    nominee_1_percentage: "text",
    nominee_2_city: "text",
    nominee_2_percentage: "text",
    nominee_timestamp: "date",
    nsdl_timestamp: "date",
    nsdl_uat_timestamp: "date",
    nse_cash: "checkbox",
    nse_currency: "checkbox",
    nse_fo: "checkbox",
    nse_timestamp: "date",
    nse_uat_timestamp: "date",
    occupation: {
      type: "select",
      values: [
        "Private sector",
        "Public sector",
        "Government Service",
        "Business",
        "Professional",
        "Agriculturist",
        "Retired",
        "House Wife",
        "Student",
        "Other",
      ],
    },
    otp: "text",
    pan_from_digilocker: "text",
    pan_number: "text",
    pan_status: "text",
    pan_timestamp: "date",
    pan_upload: "file",
    pan_upload_timestamp: "date",
    panname_for_digilocker: "text",
    panno_for_digilocker: "text",
    payment_gateway_amount: "text",
    payment_gateway_email: "text",
    payment_gateway_mobile: "text",
    payment_gateway_name: "text",
    payment_status: "text",
    pdf_timestamp: "date",
    pennydrop_accountholder_name: "text",
    pennydrop_mobile: "text",
    pennydrop_name: "text",
    pennydrop_verify: "text",
    pennydrop_verify_time: "text",
    personal_details_timestamp: "date",
    politically_exposed: {
      type: "select",
      values: ["Yes", "No"],
    },
    reenter_account_number: "text",
    scheme: "text",
    segments_timestamp: "date",
    select_dependancy: {
      type: "select",
      values: ["Self", "Spouse", "child Dependent", "parents Dependent"],
    },
    select_scheme: {
      type: "select",
      values: ["Scheme A", "Scheme B", "Scheme C", "Scheme D", "Scheme E"],
    },
    select_trading_preferences: {
      type: "select",
      values: ["Demat & Trading Both", "Only Demat", "Only Trading"],
    },
    sign_upload_timestamp: "date",
    signature_upload: "file",
    spouse_name: "text",
    state: "text",
    temp_pan_no: "text",
    trading_experience: "text",
    transaction_id: "text",
    uploadPAN: "image",
    upload_bank_proof: "file",
    upload_income_proof: "file",
  };

  let data={}
  useEffect(() => {
    const fetchData = async () => {
      try {
          const newOptions = signers.map((signer, index) => ({
            value: { variableName: `signer-${signer.sequence}`, data_type: "watermark_image", values: [] },
            label: `signer-${signer.sequence}`
        })); 
        console.log("newOptions",newOptions);
        dispatch(selectOptions(newOptions));
      } catch (error) {
        console.error("Error fetching default data:", error);
      }
    };

    fetchData();
  }, [uploadedDocument, signers]);

  useEffect(() => {
    const normalizeCoordinateTemplates = (response) => {
      const rawList =
        response?.data ||
        response?.body ||
        response?.result ||
        response?.coordinates ||
        response?.templates ||
        response;

      if (!Array.isArray(rawList)) {
        return [];
      }

      return rawList
        .map((item, index) => {
          if (typeof item === "string") {
            return {
              id: item,
              label: item,
              value: item,
            };
          }

          const value =
            item?.coordinate_name ||
            item?.name ||
            item?.template_name ||
            item?.label ||
            `Coordinates ${index + 1}`;

          return {
            id: item?.id || item?.coordinate_id || value,
            label: value,
            value,
            raw: item,
          };
        })
        .filter((item) => item?.value);
    };

    const fetchCoordinateTemplates = async () => {
      try {
        const response = await esignToolApi.fetchSignerCoordinatesList();
        const normalizedTemplates = normalizeCoordinateTemplates(response);
        setCoordinateTemplates(normalizedTemplates);
        setSelectedCoordinateTemplate("");
      } catch (error) {
        console.error("Error fetching coordinate templates:", error);
      }
    };

    fetchCoordinateTemplates();
  }, []);

  const hasTemplateCoordinates = (templateDocument) => {
    if (!templateDocument || typeof templateDocument !== "object") {
      return false;
    }

    return Object.values(templateDocument).some(
      (pageData) =>
        pageData &&
        typeof pageData === "object" &&
        Object.values(pageData).some(
          (fieldCoordinates) =>
            Array.isArray(fieldCoordinates) && fieldCoordinates.length > 0
        )
    );
  };

  const handleCoordinateTemplateChange = (event) => {
    const selectedValue = event.target.value;

    const selectedTemplate = coordinateTemplates.find(
      (template) => template.value === selectedValue
    );

    const templateDocument =
      selectedTemplate?.raw?.document_template ||
      selectedTemplate?.raw?.template_data?.document_template ||
      selectedTemplate?.raw?.templateData?.document_template;

    if (hasTemplateCoordinates(templateDocument) && (!signers || signers.length === 0)) {
      toast.warning("Add minimum one signer to proceed.");
      setSelectedCoordinateTemplate("");
      return;
    }

    setSelectedCoordinateTemplate(selectedValue);

    if (templateDocument) {
      const transformedTemplateCoordinates = transformData(templateDocument);
      dispatch(updateAllCoordinates(transformedTemplateCoordinates));
    } else {
      toast.warning("Selected template has no coordinates.");
    }
  };
  
  return (  
    <>  
    
    <Box
        sx={{
          flexGrow: 1,
          p: "24px 0 18px 35px",
          width: "100%",
          transition: "margin 0.3s ease",
          height: "100vh",
          display: "flex",
          background: "#f9f9f9",
          gap: 3
        }} 
      >
          <Box
              mt={10}
              style={{
              borderRadius: '12px',
              textAlign: 'center',
              background: '#fff',
              width: openSideBar ? 'calc(100% - 447px)' : '93%',
              height: "calc(100% - 157px)",
              marginLeft: open ? "" : "1em",
              }}
          >
              <Box sx={{ height: '80px', display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 2em" }}>
                  <Box sx={{ flex: 1, minWidth: 0, overflow: "auto" }}>
                    <Tools containerRef={containerRef} pdfPagesRef={pdfPagesRef} />
                  </Box>
                  {coordinateTemplates.length > 0 && (
                    <Box sx={{ minWidth: "196px", ml: 2, flexShrink: 0 }}>
                      <TextField
                        select
                        fullWidth
                        value={selectedCoordinateTemplate}
                        onChange={handleCoordinateTemplateChange}
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "14px",
                            background: "#FFFFFF",
                            minHeight: "46px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#E0E0E0",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#E0E0E0",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#E0E0E0",
                            },
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "16px",
                            fontWeight: 500,
                            color: "#1D1D1D",
                            py: "12px",
                          },
                        }}
                      >
                        <MenuItem value="">
                          Select Template
                        </MenuItem>
                        {coordinateTemplates.map((template) => (
                          <MenuItem key={template.id} value={template.value}>
                            {template.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  )}
                  {/* <Box sx={{ display: "flex", gap: 2 }}>
                    <PdfControls
                        containerRef={containerRef}
                        pdfPagesRef={pdfPagesRef}
                        pdfPages={pdfPages}
                      />
                  </Box> */}
              </Box>
              <Divider sx={{ borderWidth : "1px" }} />
              <Box sx={{ borderRadius: '12px', textAlign: 'center', background: '#fff', width: "100%", height: "100%", alignItems: "center", justifyContent: "center", overflow: "auto" }} >
                <PdfViewer
                    containerRef={containerRef}
                    pdfPagesRef={pdfPagesRef}
                    pdfPages={pdfPages}
                    setPdfPages={setPdfPages}
                  />
              </Box>
          </Box>
          <PdfMiniSidenav containerRef={containerRef} pdfPagesRef={pdfPagesRef} pdfPages={pdfPages} />
          
      </Box>
    {/* <Stack direction={"row"} sx={{ width: "100%" }}> 
      <Stack>
      {open.open && (<>
        <Tools containerRef={containerRef} pdfPagesRef={pdfPagesRef} />
        <PdfViewer
          containerRef={containerRef}
          pdfPagesRef={pdfPagesRef}
          pdfPages={pdfPages}
          setPdfPages={setPdfPages}
        />
        
        </>)}
      </Stack>
    </Stack> */}
    </>
  );
};

export default PdfViewport;
